import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { t_tableData } from 'src/app/components/data/write-parameter/parameter-data/parameter-data.component';
import { DidConfigService } from 'src/app/services/apiHandler/did-config/did-config.service';

@Component({
  selector: 'app-conf-dialog',
  templateUrl: './conf-dialog.component.html',
  styleUrls: ['./conf-dialog.component.scss']
})
export class ConfDialogComponent {

  public dataSet: t_tableData[];
  public displayColumns: string[] = ["name", "curr_value", "new_value"];
  public empty: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) data: t_tableData[], private dialogRef: MatDialogRef<ConfDialogComponent>, private didService: DidConfigService){
    dialogRef.disableClose = true;
    this.dataSet = data;
    if(this.dataSet.length == 0) {
      this.empty = true;
    }
  }

  public setNewData(){
    this.dataSet.forEach((set) => {
      this.didService.writeDataByID(set.ecu!, set.did!, Number(set.chosenValue)).subscribe();
    });
    this.dialogRef.close(this.dataSet);
  }

}
